import ActionTypes from './actionType';

export function scoreViewDispatch(payload){
    return{
        type: ActionTypes.ScoreView,
        payload
    }
}



// WEBPACK FOOTER //
// ./src/reducers/container/scoreDispatch.jsx